var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3a8ex0rjja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15560",
    style: {
      fill: "none"
    },
    d: "M0 0h60v70H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59817",
    d: "m0 38.841 4.5 3.765v-3.765z",
    transform: "translate(0 -11.227)",
    style: {
      fill: "#5e6f75"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 896"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 895",
    style: {
      clipPath: "url(#3a8ex0rjja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59818",
    d: "M44.456 0H8.789a3.4 3.4 0 0 0-3.378 3.419v63.163A3.4 3.4 0 0 0 8.789 70h49.442a3.4 3.4 0 0 0 3.378-3.418V17.453a.712.712 0 0 0-.2-.5L44.955.21a.7.7 0 0 0-.5-.21",
    transform: "translate(-1.61)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59819",
    d: "M58.529 69.578H9.086a2.692 2.692 0 0 1-2.675-2.708V3.707A2.692 2.692 0 0 1 9.086 1h35.668L61.2 17.742V66.87a2.692 2.692 0 0 1-2.676 2.708",
    transform: "translate(-1.907 -.289)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15555",
    transform: "translate(15.471 34.289)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.86v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15556",
    transform: "translate(15.471 42.829)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.86v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15557",
    transform: "translate(15.471 51.369)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.86v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15558",
    transform: "translate(15.471 59.91)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.86v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15559",
    transform: "translate(0 11.904)",
    style: {
      fill: "#acb9bf"
    },
    d: "M0 0h34.523v15.71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59820",
    d: "M11.889 29.7v-6.809h1.988a3.082 3.082 0 0 1 1.583.4 2.734 2.734 0 0 1 1.071 1.141 3.665 3.665 0 0 1 .379 1.693v.341a3.646 3.646 0 0 1-.381 1.7 2.7 2.7 0 0 1-1.085 1.132 3.233 3.233 0 0 1-1.616.4zm1.17-5.857v4.912h.762a1.747 1.747 0 0 0 1.413-.582 2.563 2.563 0 0 0 .5-1.673v-.379a2.631 2.631 0 0 0-.476-1.693 1.681 1.681 0 0 0-1.383-.584z",
    transform: "translate(-3.537 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59821",
    d: "M26.109 26.437a4.222 4.222 0 0 1-.342 1.757 2.607 2.607 0 0 1-.978 1.16 2.685 2.685 0 0 1-3.91-1.154 4.076 4.076 0 0 1-.354-1.725v-.384a4.192 4.192 0 0 1 .349-1.76 2.573 2.573 0 0 1 2.443-1.572 2.684 2.684 0 0 1 1.459.4 2.621 2.621 0 0 1 .982 1.151 4.183 4.183 0 0 1 .351 1.748zm-1.17-.355a3 3 0 0 0-.423-1.735 1.481 1.481 0 0 0-2.385 0 2.947 2.947 0 0 0-.437 1.7v.393a2.983 2.983 0 0 0 .432 1.735 1.386 1.386 0 0 0 1.2.613 1.37 1.37 0 0 0 1.2-.6 3.042 3.042 0 0 0 .419-1.75z",
    transform: "translate(-6.105 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59822",
    d: "M35.313 27.447a2.474 2.474 0 0 1-.8 1.7 2.688 2.688 0 0 1-1.844.611 2.607 2.607 0 0 1-1.417-.386 2.526 2.526 0 0 1-.946-1.1 4 4 0 0 1-.346-1.652v-.636a4.027 4.027 0 0 1 .337-1.7 2.564 2.564 0 0 1 .969-1.133 2.676 2.676 0 0 1 1.458-.4 2.4 2.4 0 0 1 2.589 2.349h-1.164a1.693 1.693 0 0 0-.423-1.059 1.389 1.389 0 0 0-1-.325 1.362 1.362 0 0 0-1.173.564 2.846 2.846 0 0 0-.417 1.655v.6a3.02 3.02 0 0 0 .39 1.686 1.291 1.291 0 0 0 1.144.58 1.5 1.5 0 0 0 1.036-.313 1.645 1.645 0 0 0 .439-1.044z",
    transform: "translate(-8.914 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59823",
    d: "M13.6 30.019h-1.934a.531.531 0 0 1-.527-.533v-6.812a.531.531 0 0 1 .527-.533h1.988a3.625 3.625 0 0 1 1.846.473 3.261 3.261 0 0 1 1.274 1.358 4.2 4.2 0 0 1 .439 1.939v.341a4.193 4.193 0 0 1-.442 1.951 3.226 3.226 0 0 1-1.3 1.35 3.772 3.772 0 0 1-1.872.465m-1.411-1.066h.312a.537.537 0 0 1-.191-.412v-4.911a.535.535 0 0 1 .2-.422h-.32zm3.374-4.911a3.325 3.325 0 0 1 .474 1.865v.379a3.176 3.176 0 0 1-.559 1.934 2.226 2.226 0 0 0 .357-.511 3.117 3.117 0 0 0 .322-1.455v-.341a3.15 3.15 0 0 0-.32-1.448 2.456 2.456 0 0 0-.273-.422m-2.2 3.966h.237a1.24 1.24 0 0 0 1.012-.4 2.063 2.063 0 0 0 .376-1.33v-.374a2.138 2.138 0 0 0-.356-1.354 1.177 1.177 0 0 0-.976-.39h-.292z",
    transform: "translate(-3.313 -6.4)",
    style: {
      fill: "#5e6f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59824",
    d: "M23.1 30.076a3.132 3.132 0 0 1-2.924-1.863 4.63 4.63 0 0 1-.4-1.952v-.386a4.739 4.739 0 0 1 .4-1.983 3.175 3.175 0 0 1 1.179-1.392 3.379 3.379 0 0 1 3.476-.006 3.149 3.149 0 0 1 1.182 1.378 4.741 4.741 0 0 1 .4 1.971v.382a4.763 4.763 0 0 1-.391 1.979 3.135 3.135 0 0 1-1.176 1.389 3.193 3.193 0 0 1-1.744.487m-1.432-6.495a2.2 2.2 0 0 0-.541.755 3.672 3.672 0 0 0-.3 1.535v.384a3.558 3.558 0 0 0 .3 1.5 2.236 2.236 0 0 0 .484.689 2.251 2.251 0 0 1-.141-.179 3.508 3.508 0 0 1-.53-2.045v-.393a3.479 3.479 0 0 1 .537-2.013 2.246 2.246 0 0 1 .189-.23m2.887.028a2.107 2.107 0 0 1 .167.208 3.482 3.482 0 0 1 .521 2.045v.355a3.524 3.524 0 0 1-.516 2.058c-.03.042-.061.084-.093.123a2.249 2.249 0 0 0 .431-.647 3.707 3.707 0 0 0 .294-1.534v-.379a3.662 3.662 0 0 0-.3-1.522 2.209 2.209 0 0 0-.5-.707m-1.463.446a.851.851 0 0 0-.758.379A2.463 2.463 0 0 0 22 25.833v.388a2.5 2.5 0 0 0 .334 1.426.862.862 0 0 0 .771.389.846.846 0 0 0 .765-.373 2.568 2.568 0 0 0 .322-1.442v-.355a2.526 2.526 0 0 0-.325-1.427.857.857 0 0 0-.771-.38",
    transform: "translate(-5.882 -6.363)",
    style: {
      fill: "#5e6f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59825",
    d: "M32.451 30.075a3.129 3.129 0 0 1-1.7-.467 3.062 3.062 0 0 1-1.144-1.321 4.568 4.568 0 0 1-.4-1.872v-.644a4.568 4.568 0 0 1 .387-1.923 3.1 3.1 0 0 1 1.168-1.36 3.206 3.206 0 0 1 1.737-.478 2.923 2.923 0 0 1 3.108 2.819.537.537 0 0 1-.133.411.527.527 0 0 1-.391.176h-1.158a.53.53 0 0 1-.523-.472 1.244 1.244 0 0 0-.262-.734.911.911 0 0 0-.634-.178.836.836 0 0 0-.748.347 2.365 2.365 0 0 0-.315 1.344v.6a2.536 2.536 0 0 0 .3 1.386.77.77 0 0 0 .708.347 1.04 1.04 0 0 0 .684-.178 1.183 1.183 0 0 0 .268-.714.529.529 0 0 1 .523-.465h1.164a.525.525 0 0 1 .39.174.537.537 0 0 1 .135.409 3 3 0 0 1-.974 2.053 3.209 3.209 0 0 1-2.191.742m1.906-2.311a2.1 2.1 0 0 1-.306.668 1.745 1.745 0 0 0 .4-.668zm-3.45-4.014a2.254 2.254 0 0 0-.35.548 3.516 3.516 0 0 0-.288 1.473v.636a3.485 3.485 0 0 0 .3 1.423 2.181 2.181 0 0 0 .348.535c-.015-.019-.028-.039-.042-.06a3.493 3.493 0 0 1-.481-1.986v-.6a3.338 3.338 0 0 1 .517-1.967m3.457.6h.086a1.8 1.8 0 0 0-.394-.693 2.07 2.07 0 0 1 .308.693",
    transform: "translate(-8.69 -6.362)",
    style: {
      fill: "#5e6f75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59826",
    d: "M11.889 29.7v-6.809h1.988a3.082 3.082 0 0 1 1.583.4 2.734 2.734 0 0 1 1.071 1.141 3.665 3.665 0 0 1 .379 1.693v.341a3.646 3.646 0 0 1-.381 1.7 2.7 2.7 0 0 1-1.085 1.132 3.233 3.233 0 0 1-1.616.4zm1.17-5.857v4.912h.762a1.747 1.747 0 0 0 1.413-.582 2.563 2.563 0 0 0 .5-1.673v-.379a2.631 2.631 0 0 0-.476-1.693 1.681 1.681 0 0 0-1.383-.584z",
    transform: "translate(-3.537 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59827",
    d: "M26.109 26.437a4.222 4.222 0 0 1-.342 1.757 2.607 2.607 0 0 1-.978 1.16 2.685 2.685 0 0 1-3.91-1.154 4.076 4.076 0 0 1-.354-1.725v-.384a4.192 4.192 0 0 1 .349-1.76 2.573 2.573 0 0 1 2.443-1.572 2.684 2.684 0 0 1 1.459.4 2.621 2.621 0 0 1 .982 1.151 4.183 4.183 0 0 1 .351 1.748zm-1.17-.355a3 3 0 0 0-.423-1.735 1.481 1.481 0 0 0-2.385 0 2.947 2.947 0 0 0-.437 1.7v.393a2.983 2.983 0 0 0 .432 1.735 1.386 1.386 0 0 0 1.2.613 1.37 1.37 0 0 0 1.2-.6 3.042 3.042 0 0 0 .419-1.75z",
    transform: "translate(-6.105 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59828",
    d: "M35.313 27.447a2.474 2.474 0 0 1-.8 1.7 2.688 2.688 0 0 1-1.844.611 2.607 2.607 0 0 1-1.417-.386 2.526 2.526 0 0 1-.946-1.1 4 4 0 0 1-.346-1.652v-.636a4.027 4.027 0 0 1 .337-1.7 2.564 2.564 0 0 1 .969-1.133 2.676 2.676 0 0 1 1.458-.4 2.4 2.4 0 0 1 2.589 2.349h-1.164a1.693 1.693 0 0 0-.423-1.059 1.389 1.389 0 0 0-1-.325 1.362 1.362 0 0 0-1.173.564 2.846 2.846 0 0 0-.417 1.655v.6a3.02 3.02 0 0 0 .39 1.686 1.291 1.291 0 0 0 1.144.58 1.5 1.5 0 0 0 1.036-.313 1.645 1.645 0 0 0 .439-1.044z",
    transform: "translate(-8.914 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59829",
    d: "M62.067 17.453h16.075L60.989 0v16.362a1.085 1.085 0 0 0 1.078 1.091",
    transform: "translate(-18.142)",
    style: {
      fill: "#ddd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoc);
export default __webpack_public_path__ + "static/media/ico_doc.1ec629a9ed2f7350694e567eb51f750c.svg";
export { ForwardRef as ReactComponent };